<ion-content class="login-card-shell" [fullscreen]="true">
  <main class="login-card-shell__center">
    <ion-card class="login-card">
      <ion-card-header class="login-card__header">
        <ng-content select="[logo]" />
        <ng-content select="[subtitle]" />
      </ion-card-header>

      <ion-card-content>
        @if (error(); as message) {
        <p class="login-card__error" role="alert">{{ message }}</p>
        }

        <x-button
          [label]="actionLabel()"
          [disabled]="loading()"
          [loading]="loading()"
          [loadingText]="loadingText()"
          (click)="signIn.emit()"
        />

        <ng-content select="[footer]" />
      </ion-card-content>
    </ion-card>
  </main>
</ion-content>
